import React, { useState } from 'react';
import PropTypes, { object } from 'prop-types';
import { rolesTableConf } from './helpers/configurates';
import cn from 'classnames';

import { Table, Text, Tag } from 'components/common/Elements/Elements';

import classes from './RolesSettingsTable.module.scss';
import { jarvisRoleNames } from 'data/constants';

const RolesSettingsTable = ({ tableData }) => {
  const [row, setRow] = useState('');

  const mouseEnter = e => {
    setRow(e.currentTarget.getAttribute('r'));
  };

  const mouseLeave = () => {
    setRow('');
  };

  return (
    <Table fixed>
      <Table.Header>
        <Table.Row withBorder={false}>
          {rolesTableConf.map(({ field, title }, ind) => (
            <Table.HeaderCell
              key={field}
              className={cn(classes.headerCell, classes[field])}
              onMouseEnter={mouseEnter}
              onMouseLeave={mouseLeave}
              r={`r${ind}`}
              title={title}
            />
          ))}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {tableData.map(role => (
          <Table.Row key={role._id}>
            <Table.Cell
              className={cn(classes.tableCell, row === 'r0' && classes.hov)}
              onMouseEnter={mouseEnter}
              classNameContent={classes.content}
            >
              <Text>{jarvisRoleNames[role.name]}</Text>
            </Table.Cell>
            <Table.Cell
              className={cn(classes.tableCell, row === 'r1' && classes.hov)}
              onMouseEnter={mouseEnter}
              classNameContent={classes.content}
            >
              <div className={classes.flex}>
                {role.inherits.map((inh, index) => (
                  <Text
                    className={classes.inherit}
                    key={`${role._id}-${index}`}
                  >
                    {inh}
                  </Text>
                ))}
              </div>
            </Table.Cell>
            <Table.Cell
              className={cn(classes.tableCell, row === 'r2' && classes.hov)}
              onMouseEnter={mouseEnter}
              classNameContent={classes.content}
            >
              <div className={classes.flex}>
                {role.permissions.map(perm => (
                  <Tag tag={perm} key={perm} />
                ))}
              </div>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

RolesSettingsTable.propTypes = {
  tableData: PropTypes.arrayOf(object)
};

export default RolesSettingsTable;
